import * as types from '../mutations'
import ShipmentService from '@/services/ShipmentService'

const state = {
  selectedShipment: {},
  shipments: [],
  count: 0,
  filteredShipments: [],
  loading: true
}

const getters = {
  selectedShipment: (state) => state.selectedShipment,
  shipments: (state) => state.shipments,
  shipmentCount: (state) => state.count,
  filteredShipments: (state) => state.filteredShipments,
  shipmentLoading: (state) => state.loading,

  getUnprocessedShipmentListForIngredient: (state) => (ingredient) => {
    return state.shipments.filter((shipment) => {
      return !shipment.processed_at && shipment.ingredient.id === ingredient
    })
  },

  getShipmentsForLot: (state) => (lotId) => {
    if (!state.shipments.length) {
      return {}
    }

    return state.shipments.filter((shipment) => {
      return shipment.lot === lotId
    })
  }
}

const actions = {
  selectShipment ({ commit, dispatch }, { shipment }) {
    commit(types.SELECT_SHIPMENT, shipment)
  },

  clearShipmentSelection ({ commit }) {
    commit(types.CLEAR_SHIPMENT_SELECTION)
  },

  async searchShipment ({ commit }, { search, owner }) {
    commit(types.SHIPMENT_LOADING)
    let data = await ShipmentService.loadShipments(owner, search)
    commit(types.SET_FILTERED_SHIPMENT_LIST, data)
    commit(types.SHIPMENT_LOADED)
  },

  async loadShipmentList ({ commit }, { owner }) {
    commit(types.SHIPMENT_LOADING)
    let data = await ShipmentService.loadShipments(owner)
    commit(types.SET_SHIPMENT_LIST, data)
    commit(types.SET_FILTERED_SHIPMENT_LIST, data)
    commit(types.SHIPMENT_LOADED)
  },

  async createShipment ({ commit, dispatch }, { shipment }) {
    let res = await ShipmentService.createShipment(shipment)
    commit(types.SHIPMENT_CREATED, res)
    return Promise.resolve(res.id)
  },

  async updateShipment ({ commit, dispatch }, { shipment }) {
    let res = await ShipmentService.updateShipment(shipment)
    commit(types.SHIPMENT_UPDATED, res)
    dispatch('selectShipment', { shipment: res })
    return Promise.resolve(res.id)
  },

  async checkShipmentId ({ commit }, id) {
    try {
      let res = await ShipmentService.checkSlug(id)
      return Promise.resolve(res)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}

const mutations = {

  [types.SELECT_SHIPMENT] (state, shipment) {
    state.selectedShipment = shipment
  },

  [types.CLEAR_SHIPMENT_SELECTION] (state) {
    state.selectedShipment = {}
  },

  [types.SET_SHIPMENT_LIST] (state, data) {
    state.shipments = data.results
  },

  [types.SET_FILTERED_SHIPMENT_LIST] (state, data) {
    state.filteredShipments = data.results
    state.count = data.count
  },

  [types.SHIPMENT_CREATED] (state, shipment) {
    state.shipments.unshift(shipment)
  },

  [types.SHIPMENT_LOADING] (state) {
    state.loading = true
  },

  [types.SHIPMENT_LOADED] (state) {
    state.loading = false
  },

  [types.SHIPMENT_UPDATED] (state, shipment) {
    let index = state.shipments.findIndex((s) => {
      return s.id === shipment.id
    })

    state.shipments[index] = shipment
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
